import { profileService } from "../services/profile";

const namespace = "profile";

const initialState = {
  profile: null,
  loading: {
    fetch: false,
  },
};
export const fetch = (id) => ({
  type: `${namespace}/fetch`,
  payload: id,
});

export const update = (data, id) => ({
  type: `${namespace}/update`,
  payload: { data, id },
});

export const markRead = () => ({
  type: `${namespace}/markRead`,
});

export const incrementCount = () => ({
  type: `${namespace}/incrementCount`,
});

export default {
  namespace,
  state: initialState,
  effects: {
    *incrementCount(_, { select, put }) {
      const profile = yield select((state) => state.profile.profile);
      if (!profile) return;
      yield put({
        type: "updateCount",
      });
    },

    *markRead(_, { call, put }) {
      try {
        yield call(profileService.markRead);
        yield put({ type: "setProfile", profile: { unread_noti_count: 0 } });
      } catch (error) {
        console.error("Error marking notifications as read:", error);
      }
    },
    *update({ payload }, { call, put }) {
      try {
        const response = yield call(
          profileService.update,
          payload.data,
          payload.id
        );
        yield put({ type: "setProfile", profile: response.data });
      } catch (error) {
        console.error("Error updating profile:", error);
      }
    },
    *fetch({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "fetch" });
      try {
        const response = yield call(profileService.fetch, payload);
        yield put({ type: "setProfile", profile: response.data });
        yield put({ type: "stopLoading", loadingType: "fetch" });
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    },
  },
  reducers: {
    updateCount(state) {
      return {
        ...state,
        profile: {
          ...state.profile,
          unread_noti_count: state.profile.unread_noti_count + 1,
        },
      };
    },
    setProfile(state, { profile }) {
      return { ...state, profile };
    },
    startLoading(state, { loadingType }) {
      return { ...state, loading: { ...state.loading, [loadingType]: true } };
    },
    stopLoading(state, { loadingType }) {
      return { ...state, loading: { ...state.loading, [loadingType]: false } };
    },
  },
};
